export default "/list/static/images/custom-marker.png";